import { Container } from 'pixi.js';
import { ScrollBox } from '@pixi/ui';
import { COLORS } from '../app/theme';

/** Vertical scrollable list over @pixi/ui's ScrollBox — used for table lists, online list, history. */
export class ScrollList extends Container {
  private readonly box: ScrollBox;
  private items: Container[] = [];
  readonly contentWidth: number;

  constructor(width: number, height: number) {
    super();
    const padding = 6;
    this.contentWidth = width - padding * 2;
    this.box = new ScrollBox({
      width,
      height,
      type: 'vertical',
      elementsMargin: 12,
      padding,
      radius: 12,
      background: COLORS.panelSoft,
    });
    this.addChild(this.box);
  }

  setItems(items: Container[]): void {
    this.box.removeItems();
    // Destroy the previous batch so repeated refreshes (search results, avatar grid re-rings, history)
    // don't orphan detached Containers + their event listeners until the whole scene tears down.
    for (const old of this.items) old.destroy({ children: true });
    this.items = items;
    if (items.length) this.box.addItems(items);
    // Replacing/filtering a collection must not retain an offset from the previous collection.
    // A stale offset can leave the new first row underneath the rounded viewport mask.
    this.box.scrollTop();
  }
}
